module.exports = __webpack_public_path__ + "img/dep_babyfoodandcare@3x.f713e5bd.png";